export const TEST_ID = 'navigationItem';
